import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class HeadingSchemaPlugin extends SchemaPlugin {
  nodes = {
    h1: this.makeHeading('h1'),
    h2: this.makeHeading('h2'),
    h3: this.makeHeading('h3'),
    h4: this.makeHeading('h4'),
    h5: this.makeHeading('h5'),
    h6: this.makeHeading('h6')
  } satisfies Record<string, NodeSpec>;

  makeHeading(tagName: string): NodeSpec {
    return {
      content: 'inline*',
      group: 'block',
      linkBucket: 'heading',
      defining: true,
      parseDOM: [{ tag: tagName }],
      toDOM(node) { return nodeToDOM(node); },
      tagName
    };
  }
}
